import { render, staticRenderFns } from "./FacebookMessanger.vue?vue&type=template&id=6bc44c04&"
import script from "./FacebookMessanger.vue?vue&type=script&lang=js&"
export * from "./FacebookMessanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports